import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
    const colonneSwipers = document.querySelectorAll('.swiperColonnes');
    const allModalSwipers = {};

    colonneSwipers.forEach(swiperEl => {
        const uid = swiperEl.dataset.modalTarget;
        const modal = document.querySelector(`.diapo-modal[data-modal-id="${uid}"]`);
        const closeBtn = modal.querySelector('.btn-close');
        const modalSwiperEl = modal.querySelector(`.swiperModal[data-modal-id="${uid}"]`);

        const mainSwiper = new Swiper(swiperEl, {
            modules: [Navigation, Autoplay],
            loop: true,
            spaceBetween: 20,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
        });

        const modalSwiper = new Swiper(modalSwiperEl, {
            modules: [Navigation],
            loop: true,
            spaceBetween: 20,
            navigation: {
                nextEl: modalSwiperEl.querySelector('.swiper-button-next'),
                prevEl: modalSwiperEl.querySelector('.swiper-button-prev'),
            },
        });

        allModalSwipers[uid] = modalSwiper;

        swiperEl.addEventListener('click', (e) => {
            if (e.target.closest('.swiper-button-prev') || e.target.closest('.swiper-button-next')) return;

            const currentIndex = mainSwiper.realIndex;
            modal.classList.remove('d-none');
            allModalSwipers[uid].slideToLoop(currentIndex, 0);
        });

        closeBtn.addEventListener('click', () => {
            modal.classList.add('d-none');
        });

        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.classList.add('d-none');
            }
        });
    });

    const swipers = document.querySelectorAll('.productsSwiper');
    
    swipers.forEach(swiperEl => {
        new Swiper(swiperEl, {
            modules: [Pagination],
            pagination: {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
            },
            spaceBetween: 20,
            loop: true,
        })
    })
});